import React from 'react';
import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: keyof typeof LucideIcons;
  title: string;
  body?: string;
  /** Optional primary action. */
  action?: { label: string; onClick: () => void };
  className?: string;
}

/**
 * The one way to say "there's nothing here yet." Screens were each
 * hand-rolling this (or, worse, rendering an empty void — see the
 * leaderboard) which meant an empty screen read as a broken screen.
 */
export function EmptyState({ icon = 'Inbox', title, body, action, className = '' }: EmptyStateProps) {
  const Icon = (LucideIcons[icon] || LucideIcons.Inbox) as LucideIcon;
  return (
    <div
      className={`card wr-col wr-center gap-3 ${className}`}
      style={{ padding: 32, textAlign: 'center', background: 'var(--bg-2)', boxShadow: 'none' }}
    >
      <div
        aria-hidden
        className="wr-center"
        style={{
          width: 56,
          height: 56,
          borderRadius: 18,
          background: 'var(--surface)',
          color: 'var(--ink-3)',
          boxShadow: '0 0 0 1px var(--line)',
        }}
      >
        <Icon size={24} strokeWidth={2} />
      </div>
      <div style={{ fontFamily: 'var(--display)', fontWeight: 700, fontSize: 17 }}>{title}</div>
      {body && (
        <div style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.45, maxWidth: 300 }}>
          {body}
        </div>
      )}
      {action && (
        <button type="button" className="btn primary" onClick={action.onClick} style={{ marginTop: 4 }}>
          {action.label}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
